var pym = require('pym.js');
var assignIn = require('lodash.assignin');

function TelescopeLoaderChild(options) {
    //
}

// Child is a class should return itself as well as references to function: http://blog.apps.npr.org/pym.js/api/pym.js/1.0.0/pym.js.html#line520
TelescopeLoaderChild.prototype.Child = function(options) {
    var defaults = {
        //standard pym child options, all optional
        renderCallback: null,
        polling: 0,
        xdomain: '*',
        id: ''
    };

    options = assignIn({}, defaults, options);

    this.child = pym.Child(options);
    this.navigateParentTo = navigateParentTo.bind(this);
    this.remove = remove.bind(this);
    this.scrollParentTo = scrollParentTo.bind(this);
    this.sendHeight = sendHeight.bind(this);
    this.sendMessage = sendMessage.bind(this);
    this.onMessage = onMessage.bind(this);

    return this;

}

function navigateParentTo( url ){
    this.child.navigateParentTo(url);
}

function onMessage( messageType, callback ){
    //if messageType is not a string stringify it
    var msgType = (typeof messageType !== 'string') ? JSON.stringify(messageType) : messageType;
    this.child.onMessage(msgType, callback);
}

function remove(){
    this.child.remove();
}

function scrollParentTo( hash ){
    this.child.scrollParentTo(hash);
}

function sendHeight(){
    this.child.sendHeight();
}

function sendMessage( messageType, message ){
    //if messageType is not a string stringify it
    var msgType = (typeof messageType !== 'string') ? JSON.stringify(messageType) : messageType;
    //if message is not a string stringify it
    var msg = (typeof message !== 'string') ? JSON.stringify(message) : message;
    this.child.sendMessage(msgType, msg);
}

module.exports = ( new TelescopeLoaderChild );


//////////////////
// WEBPACK FOOTER
// ./node_modules/tldr-child/src/telescope-loader-child.js
// module id = 270
// module chunks = 0